export const LETTER_FILTERS = [/^[A-Ha-h]/, /^[I-Ri-r]/, /^[S-Ös-ö]/, /^[A-Öa-ö]/];

export const filterLocationsByKeyword = (locations, keyword) =>
  locations.filter(
    ({ name, town, tags }) =>
      (town && town.toLowerCase().includes(keyword.toLowerCase())) ||
      (name && name.toLowerCase().includes(keyword.toLowerCase())) ||
      (
        tags &&
        tags.filter((tag) => tag.toLowerCase().includes(keyword.toLowerCase()))
      ).length
  );

const getCityName = (officeName) => officeName.replace(/AB Previa/i, '').trim()[0];

export const filterLocationsByIndexLetter = (locations, activeFilter, filterRegex = LETTER_FILTERS[activeFilter]) => (
  locations.filter(({ name, town }) => (
    name && filterRegex.test(getCityName(name)))
    ||
    (town && filterRegex.test(town[0]))
  )
)
